import React, { Component, PropTypes } from 'react';

import styles from './styles.module.css';
import {
  ShareButtons,
  ShareCounts,
  generateShareIcon
} from 'react-share';
import ReactGA from 'react-ga';


const {
  FacebookShareButton,
  GooglePlusShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  TelegramShareButton,
  WhatsappShareButton,
  PinterestShareButton,
  VKShareButton
} = ShareButtons;

const {
  FacebookShareCount,
  GooglePlusShareCount,
  LinkedinShareCount,
  PinterestShareCount,
  VKShareCount
} = ShareCounts;


const WhatsappIcon = generateShareIcon('whatsapp');

const FacebookIcon = generateShareIcon('facebook');
const LinkedinIcon = generateShareIcon('linkedin');
const TwitterIcon = generateShareIcon('twitter');


export default class SocialShare extends Component {
  static propTypes = {
    urlToShare: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    imgSrc: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
    };
  }


  render() {

    var shareUrl = this.props.urlToShare;
    var title= this.props.title
    var description= this.props.description
    var imgSrc= this.props.imgSrc

    /*
    <WhatsappShareButton url={shareUrl} title={title} separator=": " >
      <div className={styles.iconStyle}>
        <WhatsappIcon size={50} round={false}  />
      </div>
    </WhatsappShareButton>

    <TwitterShareButton url={shareUrl} title={title} via={description} >
      <div className={styles.iconStyle}>
        <TwitterIcon size={50} round={false}  />
      </div>
    </TwitterShareButton>
    */

    return (
        <div className={styles.container}>
          <FacebookShareButton
            url={shareUrl}
            title={title}
            description={description}
            beforeOnClick={ReactGA.event({
                      category: 'Social',
                      action: 'ShareTo',
                      label: 'Facebook'
                    })}
            >
            <div className={styles.iconStyle}>
              <FacebookIcon size={50} round={false} />
            </div>
          </FacebookShareButton>

          <LinkedinShareButton
            url={shareUrl}
            title={title}
            description={description}
            beforeOnClick={ReactGA.event({
                      category: 'Social',
                      action: 'ShateTo',
                      label: "Linkedin"
                    })}
          >
            <div className={styles.iconStyle}>
              <LinkedinIcon size={50} round={false}  />
            </div>
          </LinkedinShareButton>


        </div>
    );
  }
}



// WEBPACK FOOTER //
// ../components/social/index.jsx